import NewFullscreenSearchApp from './NewFullscreenSearchApp';

export default NewFullscreenSearchApp;
